import React, { PureComponent } from 'react'
import { Popup, Button } from 'semantic-ui-react'
import PropTypes from 'prop-types'

export default class ConfirmPopup extends PureComponent {

  static defaultProps = {
    icon: 'minus',
    color: 'grey',
    position: 'top right',
    explainText: 'Are you sure?',
    confirmText: 'Yes',
    cancelText: 'No',
    trigger: 'button',
    onConfirm: () => {},
    onCancel: () => {}
  }

  static propTypes = {
    icon: PropTypes.string,
    position: PropTypes.string,
    explainText: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    trigger: PropTypes.object,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      showPopup: false
    }
  }

  onActionStart = (e) => {
    e.stopPropagation()
    this.setState({ showPopup: true })
  }

  onConfirm = () => {
    this.setState({ showPopup: false })
    this.props.onConfirm()
  }

  onCancel = () => {
    this.setState({ showPopup: false })
    this.props.onCancel()
  }

  render () {
    const trigger = React.cloneElement(this.props.trigger, {
      onClick: this.onActionStart
    })
    return (
      <Popup
        trigger={trigger}
        flowing
        hoverable
        position={this.props.position}
        on='click'
        open={this.state.showPopup}
      >
        <p>{this.props.explainText}</p>
        <Button
          color='red'
          basic
          size='mini'
          onClick={this.onConfirm}>
            {this.props.confirmText}
        </Button>
        <Button
          primary
          size='mini'
          onClick={this.onCancel}>
            {this.props.cancelText}
        </Button>
      </Popup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/ConfirmPopup.js